// extracted by mini-css-extract-plugin
export var header = "_vo-1";
export var maskBottom = "_vo-6";
export var maskMiddle = "_vo-7";
export var maskTop = "_vo-5";
export var root = "_vo-0";
export var scrollDownButton = "_vo-3";
export var scrollDownButtonHidden = "_vo-4";
export var viewport = "_vo-2";